import React from 'react';
import DishGrid from '../components/DishGrid/DishGrid';

const MenuView = () => {
  return <DishGrid />;
};

export default MenuView;
